const normalize = require("normalize.css");
import "./stories_posts.css";
import { navbar1, navbar2 } from "../../assets/navbar.js";
import reply from "../../assets/reply.svg"


//! firebase 

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, collection, doc, addDoc, serverTimestamp, query, orderBy, onSnapshot, connectFirestoreEmulator } from "firebase/firestore";
// (Remove all 'firebase/compat/*' imports)

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCQR9C60PyWEFyzSxZvg2gaJzSWvwxPrhY",
  authDomain: "ayen-code.firebaseapp.com",
  projectId: "ayen-code",
  storageBucket: "ayen-code.appspot.com",
  messagingSenderId: "678574614469",
  appId: "1:678574614469:web:8de21ecfccb4d605ff4dac",
  measurementId: "G-SNR66TK79E"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const firestore = getFirestore(app);


//*  connect to emulator

if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
  connectFirestoreEmulator(firestore, "localhost", 8080);
}

//  base url 
const baseUrl = process.env.BASE_URL;

// links to social media icons 
document.addEventListener("DOMContentLoaded", () => {

  console.log("Script is running...");

  // Ensure the script runs after the DOM is fully loaded
  const baseUrl = window.location.origin;
  const pagePath = window.location.pathname;
  const shareUrl = encodeURIComponent(`${baseUrl}${pagePath}`);
  const title = encodeURIComponent(document.querySelector('meta[property="og:title"]')?.content || document.title);
  const description = encodeURIComponent(document.querySelector('meta[property="og:description"]')?.content || '');


  const facebookIcon = document.querySelector('.social-media-icon-facebook');
  const xIcon = document.querySelector('.social-media-icon-x');
  const redditIcon = document.querySelector('.social-media-icon-reddit');
  const linkedinIcon = document.querySelector('.social-media-icon-linkedin');
  const quoraIcon = document.querySelector('.social-media-icon-quora');


  

  if (facebookIcon)
    facebookIcon.setAttribute("href", `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`);
  console.log("Facebook href set to:", facebookIcon?.href);
  
  
  if (xIcon)
    xIcon.setAttribute("href", `https://twitter.com/intent/tweet?url=${shareUrl}`);

  if (redditIcon)
    redditIcon.setAttribute("href", `https://www.reddit.com/submit?url=${shareUrl}`);
  
  if (linkedinIcon)
    linkedinIcon.setAttribute("href", `https://www.linkedin.com/shareArticle?url=${shareUrl}`);
  
  if (quoraIcon)
    quoraIcon.setAttribute("href", `https://www.quora.com/share?url=${shareUrl}`);
});





//! comments section

const containerElem = document.querySelector('.comments-container');

// Create HTML structure for the comments form
containerElem.innerHTML = `
  <div class="comments-section">
    <form class="comment-form">
      <input type="text" placeholder="Enter a Username..." required class="comment-username" />
      <textarea class="comment-input" placeholder="Write a comment..." required></textarea>
      <button type="submit">Post Comment</button>
    </form>
    <div class="comments-list"></div>
  </div>
`;

const commentForm = containerElem.querySelector('.comment-form');
const commentInput = containerElem.querySelector('.comment-input');
const userNameInput = containerElem.querySelector('.comment-username');
const commentsList = containerElem.querySelector('.comments-list');
const articleId = containerElem.dataset.articleId;

function getAvatarUrlForName(userName) {
  const safeSeed = encodeURIComponent(userName || "guest");
  return `https://api.dicebear.com/7.x/identicon/svg?seed=${safeSeed}`;
}

// -- COMMENTS: /commentsCollection/{articleId}/comments/{commentId}
const commentsRef = collection(firestore, "commentsCollection", articleId, "comments");
const commentsQuery = query(commentsRef, orderBy("createdAt"));

commentForm.addEventListener('submit', async (e) => {
  e.preventDefault();
  const text = commentInput.value.trim();
  const userName = userNameInput.value.trim();
  if (!text || !userName) return;
  const avatarUrl = getAvatarUrlForName(userName);
  await addDoc(commentsRef, {
    avatarUrl,
    userName,
    text,
    createdAt: serverTimestamp(),
  });
  commentInput.value = "";
  userNameInput.value = "";
});

// Render all comments (with live snapshot)
onSnapshot(commentsQuery, (snapshot) => {
  commentsList.innerHTML = "";
  snapshot.forEach(doc => {
    const data = doc.data();
    const div = document.createElement('div');
    div.className = 'single-comment';
    // Comment HTML
    div.innerHTML = `
      <div class="comment-meta">
        <span class="comment-date">${data.createdAt?.toDate ? data.createdAt.toDate().toLocaleString() : ''}</span>
        <button class="reply-button" data-comment-id="${doc.id}" type="button" style="background:none;border:none;cursor:pointer;display:inline-flex;align-items:center;">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
            viewBox="0 0 20 20" fill="none" style="margin-right:4px;">
            <path d="M9 4L3 10L9 16M3 10H15C16.6569 10 18 11.3431 18 13V16"
              stroke="#2e2e2e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg> Reply
        </button>
      </div>
      <div class="comment-userName">
        <img class="comment-avatar" src="${data.avatarUrl}" alt="avatar" width="32" height="32" style="border-radius:50%;vertical-align:middle;margin-right:8px;">
        ${data.userName}
      </div>
      <div class="comment-body">${data.text}</div>
      <div class="reply-form-container" style="display:none; margin-top:6px;"></div>
      <div class="replies-list"></div>
    `;
    commentsList.appendChild(div);

    // ----- REPLIES (nested under each comment) -----
    const repliesRef = collection(firestore, "commentsCollection", articleId, "comments", doc.id, "replies");
    const repliesQuery = query(repliesRef, orderBy("createdAt"));
    const repliesList = div.querySelector('.replies-list');
    onSnapshot(repliesQuery, (replySnap) => {
      repliesList.innerHTML = ""; // clear previous
      replySnap.forEach(replyDoc => {
        const replyData = replyDoc.data();
        const replyDiv = document.createElement('div');
        replyDiv.className = 'single-reply';
        replyDiv.innerHTML = `
          <div style="display:flex; align-items:center;">
            <img src="${replyData.avatarUrl}" alt="avatar" width="24" height="24" style="border-radius:50%;margin-right:8px;">
            <b>${replyData.userName}</b>
            <span style="margin-left:8px;font-size:11px;color:gray;">
              ${replyData.createdAt?.toDate ? replyData.createdAt.toDate().toLocaleString() : ''}
            </span>
          </div>
          <div>${replyData.text}</div>
        `;
        repliesList.appendChild(replyDiv);
      });
    });

    // ----- REPLY BUTTON LOGIC -----
    const replyButton = div.querySelector('.reply-button');
    const replyFormContainer = div.querySelector('.reply-form-container');
    replyButton.addEventListener('click', function() {
      if (replyFormContainer.innerHTML === "") {
        replyFormContainer.innerHTML = `
          <form class="reply-form">
            <input type="text" placeholder="Username" required class="reply-username" />
            <input type="text" placeholder="Your reply..." required class="reply-input" />
            <div class="reply-buttons"><button type="submit"> Post</button> <button type="button" class="cancel-reply">Cancel</button></div>
          </form>
        `;
        replyFormContainer.style.display = 'block';

        // handle cancel button
        const cancelButtons = document.querySelectorAll('.cancel-reply');

        cancelButtons.forEach(button => {
          button.addEventListener('click', (e) => {
            const replyFormContainer = e.target.closest('.reply-form-container');
            if (replyFormContainer) {
              replyFormContainer.innerHTML = "";
              replyFormContainer.style.display = 'none';
            }
          });
        });

        // Handle reply submission
        replyFormContainer.querySelector('.reply-form').addEventListener('submit', async (e) => {
          e.preventDefault();
          const replyUser = replyFormContainer.querySelector('.reply-username').value.trim();
          const replyText = replyFormContainer.querySelector('.reply-input').value.trim();
          if (!replyUser || !replyText) return;
          await addDoc(repliesRef, {
            userName: replyUser,
            text: replyText,
            createdAt: serverTimestamp(),
            avatarUrl: getAvatarUrlForName(replyUser),
          });
          // Clear form after submit
          replyFormContainer.innerHTML = "";
          replyFormContainer.style.display = 'none';
        });
      } else {
        replyFormContainer.innerHTML = "";
        replyFormContainer.style.display = 'none';
      }
    });
  });
});



//! footer 
//* copyright code 
document.addEventListener('DOMContentLoaded', (e) => {
    const year = new Date().getFullYear();
    document.getElementById('copyrights').innerHTML = `&copy ${year} Ayen_codes. All rights reserved.`;
})


navbar1();
navbar2();